// extracted by mini-css-extract-plugin
export default {"doughnutCard":"doughnut-card_doughnutCard__pO4jw","chart":"doughnut-card_chart__DNCI2","tableSection":"doughnut-card_tableSection__mvuot","table":"doughnut-card_table__LsfNn"};